import { createFileRoute } from "@tanstack/react-router";
import AppCard from "@/components/AppCard.tsx";
import ModulesDataGrid from "@/components/modules/datagrid/ModulesDataGrid.tsx";

export const Route = createFileRoute("/_dashboard/modules/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AppCard title={"Modules"}>
      <ModulesDataGrid />
    </AppCard>
  );
}
